import React from 'react';
import { GitMerge, GitPullRequest, XCircle, FilePenLine } from 'lucide-react';
import { prStatusIconClass } from './repoViewTheme';

export default function PrStatusIcon({ pr, className = '' }: any) {
  const color = prStatusIconClass(pr);
  const iconClass = `h-4 w-4 shrink-0 ${color} ${className}`.trim();

  if (pr?.draft) return <FilePenLine className={iconClass} aria-hidden />;
  if (pr?.merged) return <GitMerge className={iconClass} aria-hidden />;
  if (String(pr?.state || '').toLowerCase() === 'closed') {
    return <XCircle className={iconClass} aria-hidden />;
  }
  return <GitPullRequest className={iconClass} aria-hidden />;
}
